//AI-ADMIN Service Constants for pine Wed Sep 16 01:05:52 AM UTC 2026
const serviceExports = {
'aiFormAdminApiUrl':'https://schoolcode-api.collegeboard.org/pine',
'odmServiceApiUrl':'https://odm-api.collegeboard.org/pine',
'webDomain':'https://schoolcode-admin.collegeboard.org/',
'env':'pine'
}
export default serviceExports;
